export const REGION_BOUNDS = {
  NORTHEAST: [
    [38.5, -82.0],
    [47.5, -66.9],
  ],
  SOUTHEAST: [
    [24.3, -91.7],
    [36.7, -75.0],
  ],
  MIDWEST: [
    [36.5, -104.1],
    [49.5, -80.5],
  ],
  ROCKIES: [
    [36.0, -115.0],
    [49.0, -102.0],
  ],
  NORTHWEST: [
    [41.8, -125.0],
    [49.5, -110.0],
  ],
  SOUTHWEST: [
    [31.0, -125.0],
    [38.5, -102.0],
  ],
};
